import { SortOrder } from '@/enums';
import { axiosClient } from '@/hooks';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSectors = createAsyncThunk(
  'sectors/fetchSectors',
  async (
    {
      page,
      limit,
      orderBy,
      sortOrder,
      search
    }: {
      page: number;
      limit: number;
      orderBy?: string;
      sortOrder?: SortOrder;
      search?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosClient.get(`/sectors`, {
        params: {
          page,
          limit,
          ...(orderBy && { orderBy }),
          ...(sortOrder && { sortOrder }),
          ...(search && { search })
        }
      });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSectorsByDistrict = createAsyncThunk(
  'sectors/fetchSectorsByDistrict',
  async (districtId: string, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/districts/${districtId}/sectors`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
